import React, { Fragment } from 'react';
import DataTablesEnglishCourse from '../../../components/tables/dataTablesEnglishCourse';
import EnglishTeacherSchedule from './techer-schedule';

const EnglsihCourseRegister = () => {
    return (
        <Fragment>
            <div className="page-wrapper">
                <div className="container-fluid p-0">
                    <div className="row">
                        <div className="col-md-12">
                            <DataTablesEnglishCourse />
                        </div>
                        <div className='col-md-12'>
                            <EnglishTeacherSchedule />
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default EnglsihCourseRegister;